module.exports = __webpack_public_path__ + "static/media/400388_01.42c08c57.png";